import { SVGProps } from "react";

const DownArrowIcon = ({ ...props }: SVGProps<SVGSVGElement> = {}) => (
  <svg
    viewBox="0 0 24 24"
    preserveAspectRatio="xMidYMin meet"
    aria-hidden={true}
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    {...props}
  >
    <path
      d="M7.41 8.59003L12 13.17L16.59 8.59003L18 10L12 16L6 10L7.41 8.59003Z"
      fill="black"
    />
  </svg>
);

export default DownArrowIcon;
